import React, { useState, createContext } from 'react';
import { housesData } from '../data';

export const HouseContext = createContext();

export const HouseContextProvider = ({ children }) => {
  const [houses, setHouses] = useState(housesData);
  const [filteredHouses, setFilteredHouses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSearchButtonClicked, setIsSearchButtonClicked] = useState(false);

  const [country, setCountry] = useState('Location (any)');
  const [countries] = useState([]);
  const [property, setProperty] = useState('Property (any)');
  const [properties] = useState([]);
  const [price, setPrice] = useState('Price range (any)');
  const [bedrooms, setBedrooms] = useState('Bedrooms (any)');


//!================================>>>>> COUNTRY
const getFilteredHousesByCountry = (selectedCountry) => {
  setLoading(true);
  if (selectedCountry === 'Location (any)') {
    setCountry('Location (any)');
    setHouses(housesData);
    setLoading(false);
    return;
  }

  const filteredHouses = housesData.filter((house) => {
    const isCountryMatch = house.country === selectedCountry;
    const isPropertyMatch = property === 'Property (any)' || house.type === property;

    return isCountryMatch && isPropertyMatch;
  });

  console.log('HC_Array:', filteredHouses)

  setHouses(filteredHouses);
  setCountry(selectedCountry);
  setLoading(false);
};
//!================================>>>>> PROPERTY
const getFilteredHousesByProperty = (selectedProperty) => {
  setLoading(true);
  if (selectedProperty === 'Property (any)') {
    setProperty('Property (any)');
    setHouses(housesData);
    setLoading(false);
    return;
  }
  const filteredHouses = housesData.filter((house) => {
    return house.type === selectedProperty && (country === 'Location (any)' || house.country === country);
  });

  console.log('HT_Array:', filteredHouses)

  setHouses(filteredHouses);
  setProperty(selectedProperty);
  setLoading(false);
};
//!================================>>>>> PRICE
const getFilteredHousesByPrice = (selectedPrice) => {
  const { value } = selectedPrice;
  const { min, max } = value;

  if (selectedPrice.range === 'Price range (any)') {
    setHouses(housesData);
    setPrice('Price range (any)');
    setLoading(false);
    return;
  }

  const filteredHouses = housesData.filter((house) => {
    const housePrice = parseInt(house.price);
    return housePrice >= min && housePrice <= max;
  });

  console.log('HP_Array:', filteredHouses);

  setHouses(filteredHouses); 
  setPrice(selectedPrice.range);
  setLoading(false);
};
//!================================>>>>> BEDROOMS 
const getFilteredHousesByBedrooms = (selectedBedrooms) => {
  setLoading(true);
  if (selectedBedrooms === 'Bedrooms (any)') {
    setHouses(housesData);
    setBedrooms(selectedBedrooms);
    setLoading(false);
    return;
  }
  //* The logic used to display the selectedBedrooms-value in search-text 
  const parsedBedrooms = parseInt(selectedBedrooms, 10);

  console.log(parsedBedrooms)
  //* Apply only the bedrooms filter
  const filteredHouses = housesData.filter((house) => parseInt(house.bedrooms, 10) === parsedBedrooms);

  console.log('HB_Array:', filteredHouses)

  setHouses(filteredHouses);
  setBedrooms(selectedBedrooms);
  setLoading(false);
};



  return (
    <HouseContext.Provider
      value={{
        country,
        setCountry,
        countries,
        property,
        setProperty,
        properties,
        price,
        setPrice,
        bedrooms,
        setBedrooms,
        setHouses,
        houses,
        loading,
        filteredHouses,
        setFilteredHouses,
        getFilteredHousesByCountry,
        getFilteredHousesByProperty,
        getFilteredHousesByPrice,
        getFilteredHousesByBedrooms,
        isSearchButtonClicked,
        setIsSearchButtonClicked,
      }}
    >
      {children}
    </HouseContext.Provider>
  );
};